import { render, staticRenderFns } from "./StatusInfo.vue?vue&type=template&id=15bad1da&"
import script from "./StatusInfo.vue?vue&type=script&lang=js&"
export * from "./StatusInfo.vue?vue&type=script&lang=js&"
import style0 from "./StatusInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports